module.exports = __webpack_public_path__ + "static/media/tettigonia_viridissima.6df0cfbb.png";